import { fetchRunsheets } from '@/entities/schedules'
import { createSlice } from '@reduxjs/toolkit'

import { setupRunsheet } from '../thunks/setupRunsheet'

export const initialRunsheetPageState = {
  isLoading: false,
  isSuccess: false,
  isTreeViewLoading: false,
}

export const runsheetPageSlice = createSlice({
  name: 'runsheetPage',
  initialState: initialRunsheetPageState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(setupRunsheet.pending, (state, _) => {
        state.isLoading = true
        state.isSuccess = false
      })
      .addCase(setupRunsheet.fulfilled, (state, _) => {
        state.isLoading = false
        state.isSuccess = true
      })
      .addCase(setupRunsheet.rejected, (state, _) => {
        state.isLoading = false
        state.isSuccess = false
      })
      .addCase(fetchRunsheets.pending, (state, _) => {
        state.isTreeViewLoading = true
      })
      .addCase(fetchRunsheets.fulfilled, (state, _) => {
        state.isTreeViewLoading = false
      })
      .addCase(fetchRunsheets.rejected, (state, _) => {
        state.isTreeViewLoading = false
      })
  },
})
